export const getListBankOptionsMixin = {
  data: () => {
    return {
      listBank: [],
      listBankCategory: [],
      listBankType: [],
      listBankService: [],
      listBankUsage: [],
      listBankGroup: [],

      listBankLoading: true,
      listBankCategoryLoading: true,
      listBankTypeLoading: true,
      listBankServiceLoading: true,
      listBankUsageLoading: true,
      listBankGroupLoading: true,
    }
  },
  methods: {
    getListBank(bankGroupId = '') {
      let bankParam = "";

      if (bankGroupId) {
        bankParam += "?group_id=" + bankGroupId
      }

      this.listBankLoading = true;

      this.$http
        .get(process.env.VUE_APP_API_URL + "/bank" + bankParam)
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listBank = res.data.data;
            }
          }
        })
        .finally(() => {
          this.listBankLoading = false;
        });
    },
    getListBankGroup() {
      this.$http
        .get(process.env.VUE_APP_API_URL + "/bank-group")
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listBankGroup = res.data.data;
            }
          }
        })
        .finally(() => {
          this.listBankGroupLoading = false;
        });
    },
    getListBankType() {
      this.listBankTypeLoading = true;

      this.$http
        .get(process.env.VUE_APP_API_URL + "/bank-type")
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listBankType = res.data.data;
            }
          }
        })
        .finally(() => {
          this.listBankTypeLoading = false;
        });
    },
    getListBankCategory() {
      this.listBankCategoryLoading = true;

      this.$http
        .get(process.env.VUE_APP_API_URL + "/bank-category")
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listBankCategory = res.data.data;
            }
          }
        })
        .finally(() => {
          this.listBankCategoryLoading = false;
        });
    },
    getListBankUsage() {
      this.listBankUsageLoading = true;

      this.$http
        .get(process.env.VUE_APP_API_URL + "/bank-usage")
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listBankUsage = res.data.data;
            }
          }
        })
        .finally(() => {
          this.listBankUsageLoading = false;
        });
    },
    getListBankService() {
      this.listBankServiceLoading = true;

      this.$http
        .get(process.env.VUE_APP_API_URL + "/bank-service")
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listBankService = res.data.data;
            }
          }
        })
        .finally(() => {
          this.listBankServiceLoading = false;
        });
    },
  }
};